exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".contents-4526f82a{display:flex;justify-content:space-between}\n", ""]);

// Exports
exports.locals = {
	"contents": "contents-4526f82a"
};